//-------------imports--------------
import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import InputAdornment from "@mui/material/InputAdornment";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from "@mui/material/CircularProgress";

import Navbar from "../../components/common/Navbar";
import { useStyles } from "../../assets/styles/Theme";
import ViewData from "../../components/grids/ViewDatagrid";
import { Tablesdata } from "../../assets/Griddata";
import VisibilityIcon from "@mui/icons-material/Visibility";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import { useState, useEffect } from "react";
import {
  currencyFormat,
  currencyFormatLKR,
} from "../../../src/utils/common/CurrencyFormat";
import { externalgetApi } from "../../services/external/externalApis";
import { SETTINGS_API_05 } from "../../api/ApiModel";
import {
  COMPCODE,
  LOCCODE,
  RESTCODE,
  STS,
  CHAINCODE,
  MENUTYPECODE,
} from "../../api/ApiModel";
import {
  CON_STATUS_ACTIVE,
  CON_MENU_TYPE_CODE,
} from "../../utils/sys/Constants";
import { useSelector } from "react-redux";
import SearchAppBar from "../../components/common/search";
function ViewTables() {
  //----------------hooks-------------------
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, LOCCODE, RESTCODE, USERNAME } = SYS_USER.USER_PARAM || {};
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [filteredData, setFilteredData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(SETTINGS_API_05, "get", {
          COMPCODE,
          LOCCODE,
          RESTCODE,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        setIsLoading(false);
      } catch (err) {
        setError(err);
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const mapResultToRows = (result) => {
    return result.map((item, index) => ({
      id: index + 1,
      TABLENAME: item.TABLENAME,
      NOOFSEATS: item.NOOFSEATS,
      COLORCODE: item.COLORCODE,
      TABLECODE: item.TABLECODE,
      STS: item.STS,
      RATE: currencyFormatLKR(item.RATE, "LKR", false),
    }));
  };

  useEffect(() => {
    if (data) {
      const filtered = data.filter((item) => {
        return (
          item.TABLENAME.toLowerCase().includes(searchText.toLowerCase()) ||
          item.NOOFSEATS.toString()
            .toLowerCase()
            .includes(searchText.toLowerCase())
        );
      });
      setFilteredData(filtered);
    }
  }, [searchText, data]);
  //--------------------------funtions-----------------
  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
  };

  const handleItemClick = (id, actionText) => {
    if (actionText === "Edit") {
      const selectedItem = data.find((item) => item.TABLECODE === id);
      if (selectedItem) {
        navigate(`/tables`, { state: { selectedItem, actionText } });
      }
    } else {
      navigate(`/tables`, { state: { selectedItem: "" } });
    }
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      onClick: (TABLECODE) => handleItemClick(TABLECODE, "Edit"),
    },
  ];

  const rows = filteredData ? mapResultToRows(filteredData) : [];

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer1}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="hover">Home</Link>
                <Link underline="hover">Settings</Link>
                <Link underline="hover">View Tables</Link>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12} md={6} p={2}>
              <Stack
                sx={styles.AI_fixedStack1}
                direction="row"
                justifyContent="flex-end"
                spacing={2}
                padding={1}
                ml={1}
              >
                <SearchAppBar
                  onChange={handleSearchChange}
                  value={searchText}
                />
                <Button
                  onClick={() => handleItemClick()}
                  variant="contained"
                  size="medium"
                  startIcon={<AddCircleIcon />}
                  sx={{
                    background: theme.palette.primary.main,
                    color: theme.palette.text.buttontxt,
                    textTransform: "capitalize",
                    letterSpacing: "2px",
                    width: "80px",
                  }}
                >
                  Add
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </AppBar>

      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "60vh",
          }}
        >
          <CircularProgress color="primary" />
        </Box>
      ) : (
        <ViewData
          columns={Tablesdata.columns}
          rows={rows.map((item) => ({ ...item, id: item.TABLECODE }))}
          menuItems={menuItems}
          tabletitle={Tablesdata.name}
          gridid="TABLECODE"
        />
      )}
    </div>
  );
}

export default ViewTables;
